import { Serializer } from "~/types/serializer"

/**
 * Serializes the value to JSON. T must be serializable for this to work.
 */
export default class JsonSerializer<T> implements Serializer<T> {
  serialize(value: T): string {
    return JSON.stringify(value)
  }

  deserialize(raw: string): T {
    return JSON.parse(raw) as T
  }
}
